import { render, staticRenderFns } from "./DashShellComponent.vue?vue&type=template&id=7789a737&scoped=true"
import script from "./DashShellComponent.vue?vue&type=script&lang=js"
export * from "./DashShellComponent.vue?vue&type=script&lang=js"
import style0 from "./DashShellComponent.vue?vue&type=style&index=0&id=7789a737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7789a737",
  null
  
)

export default component.exports